import styled from 'styled-components/macro';

const Card = styled.div`
  background: ${(props) => props.theme.colors.backgroundPrimary};
  border-radius: 20px;
`;

export default Card;
